import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { dateUtil } from "src/app/support/date-util";
import { Observable } from "rxjs";
import { Remuneration } from "src/app/backend/models/remuneration";
import { UserNotify } from "src/app/support/notify-decorator";
import {
  omitFalsyProperties,
  omitUndefinedAndNullProperties
} from "src/app/support/object";
import { PageRequest } from "src/app/support/page-request";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";

@Injectable()
export class RemunerationBackend {
  private readonly http = inject(HttpClient);

  list(
    request: PageRequest,
    {
      from,
      to,
      memberId,
      emitted
    }: { from?: string; to?: string; memberId?: string; emitted?: string }
  ): Observable<PaginatedResult<Remuneration>> {
    return this.http.get<PaginatedResult<Remuneration>>(
      `${environment.snoots.api.billing}/remunerations`,
      {
        params: omitFalsyProperties({
          p: request.page,
          s: request.pageSize,
          ...request.filterValues,
          ...omitFalsyProperties({
            from,
            to: to
              ? dateUtil(to).add(1, "day").startOf("day").toISOString()
              : undefined,
            memberId,
            emitted
          })
        })
      }
    );
  }

  @UserNotify({
    errorMessage: marker("Impossibile esportare"),
    progressIndeterminate: true,
    progressMessage: marker("Esportazione in corso")
  })
  export({
    from,
    to,
    memberId,
    emitted
  }: {
    from?: string;
    to?: string;
    memberId?: string;
    emitted?: string | null;
  }): Observable<void> {
    return this.http.post<void>(
      `${environment.snoots.api.billing}/remunerations/exports`,
      omitUndefinedAndNullProperties({
        from,
        to: to
          ? dateUtil(to).add(1, "day").startOf("day").toISOString()
          : undefined,
        memberId,
        emitted: emitted === null ? undefined : emitted === "true"
      })
    );
  }
}
